module.exports = __webpack_public_path__ + "media/images/upload-d7f981c4aab53d04d12431a0316a9096b79fc5c082e1d86ee29895750aba42b5.svg";